import type { Notification } from "@/types/notifications";
import { useNotificationsQuery } from "./use-notifications-query";

export function useNotifications() {
  const { notificationsQuery } = useNotificationsQuery();

  return (notificationsQuery?.data || []) as Array<Notification>;
}
